import { render, staticRenderFns } from "./change_status.vue?vue&type=template&id=5a157990&scoped=true&"
import script from "./change_status.vue?vue&type=script&lang=js&"
export * from "./change_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a157990",
  null
  
)

export default component.exports